var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function ($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.search.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "search-input el-input" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.lazy",
              value: _vm.searchInputValue,
              expression: "searchInputValue",
              modifiers: { lazy: true },
            },
          ],
          staticClass: "el-input__inner",
          attrs: {
            placeholder: _vm.placeholder,
            type: "text",
            autocomplete: "off",
          },
          domProps: { value: _vm.searchInputValue },
          on: {
            change: [
              function ($event) {
                _vm.searchInputValue = $event.target.value
              },
              _vm.changeHandler,
            ],
          },
        }),
      ]),
      _vm._m(0),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "search-button" }, [
      _c("i", { staticClass: "iconfont icon-fangdajing" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }